import * as React from 'react';

import { ArgumentT } from 'routes/BudgetModule/config/types';
import Checkbox from '@mui/material/Checkbox';
import DashboardItemWrapper from 'components/DashboardItemWrapper/DashboardItemWrapper';
import { Box } from '@mui/material';

type Props = {
    changeSelection: (arg1: number) => void;
    isSelected: boolean;
    argumentaire: ArgumentT;
};

function AddToArgumentItem(props: Props): React.ReactElement {
    const { argumentaire, isSelected, changeSelection } = props;
    return (
        <DashboardItemWrapper
            dataTitle={argumentaire.title}
            onClick={() => changeSelection(argumentaire.id)}
        >
            <Checkbox
                onChange={() => changeSelection(argumentaire.id)}
                value={argumentaire.id}
                checked={isSelected}
            />
            <Box
                sx={{ flexGrow: 1, padding: '0.4rem 1rem 0.3rem 0.5rem' }}
                onChange={() => changeSelection(argumentaire.id)}
                role="button"
                tabIndex={0}
            >
                {argumentaire.title}
            </Box>
        </DashboardItemWrapper>
    );
}

export default AddToArgumentItem;
